import React from "react";

const Products = () => {
  return (
    <div className=" p-6 sm:p-10 lg:p-16">
      <h1 className="text-center text-3xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800 mb-12">
        Transforming Ideas into Cutting-Edge Solutions: Explore Our Innovations
      </h1>
      <div className="flex flex-col lg:flex-row items-center lg:space-x-16 space-y-10 lg:space-y-0 mb-10">
        <div className="flex justify-center lg:w-1/2">
          <div
            className=" rounded-lg shadow-lg group relative w-72 sm:w-80 lg:w-96 h-80 sm:h-96 overflow-hidden transition-transform duration-300 transform hover:scale-105"
            style={{
              boxShadow:
                "0 8px 16px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(59, 130, 246, 0.2), 0 4px 12px rgba(16, 185, 129, 0.2)",
            }}
          >
            <img
              src="./assets/images/recentWork/ott.jpeg"
              alt="OTT Platform"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="lg:w-1/2  lg:text-left space-y-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            OTT Platform
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed">
            Building an OTT platform app using DevOps ensures efficient,
            scalable, and high-quality development. The process starts with
            planning and developing features like streaming, user
            authentication, and payment integration while using version control
            for collaboration. Continuous integration and deployment pipelines
            automate testing and updates, ensuring fast and reliable delivery.
            Containerization with tools like Docker and Kubernetes enables
            scalability and resource efficiency. Monitoring tools like
            Prometheus or Grafana track performance and guide improvements based
            on user feedback. This streamlined approach ensures a secure,
            adaptable platform with a seamless user experience.
          </p>
          {/* <button className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-8 py-3 rounded-full shadow-lg hover:from-purple-600 hover:to-indigo-700 transition-transform transform hover:scale-105">
            Explore Features
          </button> */}
        </div>
      </div>

      <div className="flex flex-col lg:flex-row items-center lg:space-x-16 space-y-10 lg:space-y-0 mb-10">
        <div className="flex justify-center lg:w-1/2">
          <div
            className=" rounded-lg shadow-lg group relative w-72 sm:w-80 lg:w-96 h-80 sm:h-96 overflow-hidden transition-transform duration-300 transform hover:scale-105"
            style={{
              boxShadow:
                "0 8px 16px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(59, 130, 246, 0.2), 0 4px 12px rgba(16, 185, 129, 0.2)",
            }}
          >
            <img
              src="/assets/images/recentWork/voip.png"
              alt="Voice Broadcasting"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="lg:w-1/2 lg:text-left space-y-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Voice Broadcasting
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed">
            We developed a robust voice broadcasting app leveraging Asterisk and
            FreeSWITCH to deliver seamless and scalable communication solutions.
            The app enables businesses to send automated voice messages to a
            large audience efficiently. Asterisk powers the core telephony
            features, including call management and interactive voice responses
            (IVR). FreeSWITCH provides advanced media processing capabilities,
            enabling rich voice features and flexibility. The app is designed
            for scalability, reliability, and easy integration with existing
            communication systems, making it ideal for marketing campaigns,
            alerts, and customer engagement.
          </p>
          {/* <button className="bg-gradient-to-r from-blue-600 to-green-500 text-white px-8 py-3 rounded-full shadow-lg hover:from-purple-600 hover:to-indigo-700 transition-transform transform hover:scale-105">
            Explore Features
          </button> */}
        </div>
      </div>

      {/* <div className="flex flex-col lg:flex-row items-center lg:space-x-16 space-y-10 lg:space-y-0 mb-10">
        <div className="flex justify-center lg:w-1/2">
          <div
            className=" rounded-lg shadow-lg group relative w-72 sm:w-80 lg:w-96 h-80 sm:h-96 overflow-hidden transition-transform duration-300 transform hover:scale-105"
            style={{
              boxShadow:
                "0 8px 16px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(59, 130, 246, 0.2), 0 4px 12px rgba(16, 185, 129, 0.2)",
            }}
          >
            <img
              src="/assets/images/recentWork/dialer.png"
              alt="Dialer"
              className="w-full h-full object-cover"
            />
          </div>
        </div>
        <div className="lg:w-1/2 lg:text-left space-y-6">
          <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-bold text-gray-800">
            Dialer
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-600 leading-relaxed">
            This web application integrates a powerful dialer developed using
            OpenSIPS and Asterisk, delivering a seamless VoIP communication
            experience. OpenSIPS serves as the high-performance SIP server,
            managing SIP signaling and ensuring efficient call routing and
            scalability. Asterisk is leveraged for its robust media handling,
            including call bridging, voicemail, and IVR functionalities. The
            application provides an intuitive user interface for managing calls,
            contacts, and call logs, making it ideal for businesses and telecom
            operators. Features include real-time call monitoring, custom call
            routing rules, and seamless integration with existing CRM systems.
            Built with security and scalability in mind, this solution ensures
            low latency and high-quality voice communication, meeting modern
            telecommunication needs effectively.
          </p>
        </div>
      </div> */}
    </div>
  );
};

export default Products;
